import { useEffect, useState } from "react";
import "../../scss/backoffice.scss";
import { Sidemenu } from "./Sidemenu";
import { Topbar } from "./Topbar";
import { Footer } from "./Footers";
import { FileUploader } from "react-drag-drop-files";
import {
  getImgCalendarCutoff,
  UploadImgCalendarCutoff,
} from '../../services/ApiGetCalendarImgCutoff';
import Moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CutOffCalendar } from '../../model/datatype';

const fileTypes = ["jpg", "png"];
export const Payroll = (props: any) => {
  const [loder, setLoader] = useState(false);
  const [latTimeUpload, setLatTimeUpload] = useState(Date);
  const [modalShow, setModalShow] = useState(false);
  const [formModalShow, setFormModalShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [payrollImage, setPayrollImage] = useState("");
  const [file, setFile] = useState(null);
  const handleSwitch = () => {
    setChecked(!checked);
  };

  let base64Image = "";

  const handleChange = (file: any) => {
    setFile(file);
    setLoader(true);

    UploadImgCalendarCutoff(file).then((response: any) => {
      const getData: CutOffCalendar = response.data;
      setPayrollImage("data:image/jpg;base64," + getData?.image);
      const dateLast = new Date(getData?.modifiedDateTime ?? getData?.createdDateTime);
      setLatTimeUpload(Moment(dateLast).format('DD/MM/YYYY HH:mm:ss'));
      setLoader(false);
      if (getData?.image !== null) {
        toast.success('Payroll Cutoff Upload Calendar successfully.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  };

  function ramdomNumber() {
    return Math.floor(Math.random() * 90000) + 10000;
  }

  useEffect(() => {
    getImgCalendarCutoff().then((response: any) => {
      const getData: CutOffCalendar = response?.cutOffCalendar;
      console.log("CutOffCalendar Info ===>", getData);
      setPayrollImage("data:image/jpg;base64," + getData?.image);
      const dateLast = new Date(getData?.modifiedDateTime ?? getData?.createdDateTime);
      setLatTimeUpload(Moment(dateLast).format('DD/MM/YYYY HH:mm:ss'));
    });
  }, [latTimeUpload]);

  return (
    <>
      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Payroll Cutoff Uploader</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-2">
                  <div className="row my-3 px-4">
                    <div className="col-12 text-end pb-3 last-updated">
                      Last update : {latTimeUpload}
                    </div>
                    <div className="col-12 mb-4 annoucement-upload">
                      {loder ? (
                        <div className="loader fileuploader text-center pt-3">
                          <div className="spinner m-auto"></div>
                          <label>Waiting for uploading ...</label>
                        </div>
                      ) : (
                        <FileUploader
                          multiple={false}
                          handleChange={handleChange}
                          name="file"
                          types={fileTypes}
                          className="fileuploader"
                        />
                      )}
                    </div>
                    <div className="col-6 m-auto">
                      <img
                        title="image"
                        src={`${payrollImage}`}
                        className="w-100 mb-2 border"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
